"use client"

import { ReportUserDialog } from "@/components/ReportDialog"
import { FragmentType, graphql, useFragment } from "@/gql"
import { PortfolioUIState } from "../page"
import type { NovaSession } from "@/types"
import { AboutContentIsProFragmentDoc } from "@/gql/graphql"
import { usePortfolio } from "../hooks/usePortfolio"
import { AboutModal } from "./AboutModal"
import { useEditPortfolio } from "./edit/useEditPortfolio"

const PortfolioModalsFragment = graphql(`
  fragment PortfolioModals on IndividualCreative {
    id
    __typename
    user {
      id
      ...ActionsModal
    }

    ...AboutModal
  }
`)

interface Props {
  uiState: PortfolioUIState
  creative: FragmentType<typeof PortfolioModalsFragment> | null | undefined
  serverSession: NovaSession | null
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
  viewerUser: FragmentType<typeof AboutContentIsProFragmentDoc> | null | undefined
}

/**
 * Modals component handles the rendering of multiple modals within the Portfolio UI.
 */
export const Modals: React.FC<Props> = props => {
  const creative = useFragment(PortfolioModalsFragment, props.creative)

  const userId = creative?.user?.id
  const { uiState, serverSession, editProfileMethods } = props
  const { setShowReportUserModal, showReportUserModal } = usePortfolio()

  return (
    <>
      <AboutModal
        creative={creative}
        uiState={uiState}
        editProfileMethods={editProfileMethods}
        serverSession={serverSession}
        viewerUser={props.viewerUser}
      />
      <ReportUserDialog open={showReportUserModal} onOpenChange={setShowReportUserModal} userId={userId} />
    </>
  )
}
